import React, { createContext, useContext, useReducer, useMemo, useRef, useCallback } from "react"
import { quoteReducer, buildInitialState } from "./quoteReducer"

const QuoteEditorContext = createContext(null)
const RowEditorContext   = createContext(null)

export const QuoteEditorProvider = ({ data, children }) => {
  const [state, dispatch] = useReducer(quoteReducer, data, buildInitialState)

  const value = useMemo(() => ({ state, dispatch }), [state])

  const stateRef = useRef(state)
  stateRef.current = state
  const getState = useCallback(() => stateRef.current, [])

  const { account, site, currency, currencySymbol, client, readOnlyPurchasePrice, readOnlyVat } = state
  const settings = useMemo(
    () => ({ account, site, currency, currencySymbol, client, readOnlyPurchasePrice, readOnlyVat }),
    [account, site, currency, currencySymbol, client, readOnlyPurchasePrice, readOnlyVat]
  )
  const rowValue = useMemo(() => ({ settings, dispatch, getState }), [settings, getState])

  return (
    <QuoteEditorContext.Provider value={value}>
      <RowEditorContext.Provider value={rowValue}>
        {children}
      </RowEditorContext.Provider>
    </QuoteEditorContext.Provider>
  )
}

export const useQuoteEditor = () => {
  const ctx = useContext(QuoteEditorContext)
  if (!ctx) throw new Error("useQuoteEditor must be used within QuoteEditorProvider")
  return ctx
}

// Rows use this rather than useQuoteEditor, so an edit elsewhere in the quote does not re-render them.
export const useRowEditor = () => {
  const ctx = useContext(RowEditorContext)
  if (!ctx) throw new Error("useRowEditor must be used within QuoteEditorProvider")
  return ctx
}
